import { CreationDetailFragment } from '../../generated/graphql';

export const demoCreationData: { data: { creation: CreationDetailFragment } }[] = [
  {
    data: {
      creation: {
        id: 'CR01FKZ3RCFZSQ',
        projectId: 'PJ01FKZ3RCCRJS',
        creationSetId: 'CS01FKZ3RCDWM2',
        latestDeliverableUrl:
          'https://files.kaizenplatform.net/encoded/0/0/4d98607f47a93aac872b47d7c1884543896e4ec36643b5946a1690c1863d9422/bb4dc822-13bb-4272-b9fe-b4561e1cc071_prev_480p.mp4',
        assignee: {
          id: '18696',
          name: 'Kaizen Ad CS',
          profileImageUrl: '',
        },
        deliverables: [
          {
            id: 'DE01FKZ3RCGA0X',
            creative: {
              id: 'CV01FKZ3RCG5RV',
              file: {
                id:
                  'e243f9103a1843c4995d84b1588b0647b67756a8c40d41019295b0060a968970cde5d016fcc74ef0beb05087f712cc73/01DR8PC1TZ7Q_Facebook_Feeds_01DR8RJCAVRZ_kza.mp4',
                originalFileName: '01DR0RKEXG02_Facebook_Feeds_01DR112KT6NS_kza.mp4',
                url:
                  'https://files.kaizenplatform.net/encoded/0/0/4d98607f47a93aac872b47d7c1884543896e4ec36643b5946a1690c1863d9422/bb4dc822-13bb-4272-b9fe-b4561e1cc071_prev_480p.mp4',
                mimeType: 'video/mp4',
                size: 17326580,
              },
            },
            attachedThumbnail: {
              id: 'CV01FKZ3RCH32F',
              file: {
                id:
                  '3d2c05e3c02140c6a6a002ffd1b0b656e9831ad371f64629980c8b6247835ffef518df25d7a9449ba92689adce9fb049/01DR8PC1TZ7Q_Facebook_Feeds_01DR8RJCCDXH_kza.png',
                originalFileName: '01DR0RKEXG02_Facebook_Feeds_01DR112KVR8F_kza.png',
                url: 'https://files.kaizenplatform.net/instance/0/0/ce7d4842-e3a4-4d5c-856c-6e03b846a698',
                mimeType: 'image/png',
                size: 111653,
              },
            },
            intent:
              '以下の通りで制作しております。\r\n\r\n---------------\r\n全体：添付の動画サンプルを参考にBGMのテンポに合わせてテキストを表示させ、スタイリッシュなイメージになるよう全体を構成しております。\r\n※コピーライトを下部に常設しております。\r\n※クロージングの尺確保に伴い、全体の尺を17秒に変更しております。\r\n\r\nシーン1：テキスト演出を軸として、ユーザーの悩みを大きく表示させて問題提起のインパクトを強めました。\r\n\r\nシーン2：解決方法、実績情報等のコピーに合わせて過去制作事例のダイジェストを分割して表示。早い安いに加え高いクオリティが映えるように調整しました。\r\n\r\nシーン3：追加説明とイメージ動画を併せて表示 \r\n\r\nシーン4：ロゴと併せてダウンロードを促すコピーと矢印を配置。',
            state: 'submitted',
            uploadedAdPlatformKeys: [],
            createdAt: '2021-11-08T06:28:50Z',
            stateUpdatedAt: '2021-11-08T06:28:50Z',
          },
        ],
        modificationRequests: [],
        modificationRequestExpired: true,
        modificationRequestFreeExpiredAt: '2019-11-20T08:00:00Z',
        modificationRequestPoint: 40,
        modificationRequestFreeLimit: 0,
        isNextModificationRequestForAFee: true,
        state: 'submitted',
        proposed: false,
        submittedAt: '2019-10-28T08:44:09Z',
        createdAt: '2021-11-08T06:28:50Z',
        stateUpdatedAt: '2021-11-08T06:28:50Z',
        creativeFormat: {
          id: '190612',
          network: { id: '2', key: 'facebook', name: 'Facebook' },
          placement: {
            id: '2',
            key: 'facebook_feeds',
            name: 'Feeds',
            basicMerchandises: [
              {
                isModificationRequestable: true,
                creativeType: { id: '1', key: 'video', name: 'Video' },
              },
              {
                isModificationRequestable: true,
                creativeType: {
                  id: '2',
                  key: 'static_image',
                  name: 'Static Image',
                },
              },
            ],
          },
          attribute: {
            aspectRatio: {
              supportingAspectRatioId: '1',
              size: { height: 1080.0, width: 1080.0 },
              aspectRatio: { height: 1, width: 1 },
            },
            playbackTime: { supportingPlaybackTimeId: '2', seconds: 15 },
          },
          creativeType: { id: '1', key: 'video', name: 'Video' },
        },
        organization: {
          id: '29077',
          name: 'mediba（Ad）_ビジネス戦略Unit Mgr',
          pointBalance: 0,
          features: { canOpenOfferWhenDisagreed: false },
          businessRegion: {
            key: 'jp',
            idBusinessRegion: 'japan',
            timeZone: 'Asia/Tokyo',
          },
        },
        assignmentId: 'DEMOA4',
        finalized: false,
      },
    },
  },
  {
    data: {
      creation: {
        id: 'CR01FKQWW756X5',
        projectId: 'PJ01FKQWW7370Q',
        creationSetId: 'CS01FKQWW74B7X',
        latestDeliverableUrl:
          'https://files.kaizenplatform.net/encoded/0/0/fa6c641edfc5e3257c06403462e3a131112836c13d1496277f9d5b01477eb894/f686dfce-149b-4a81-85ce-d064a505385b_prev_480p.mp4',
        assignee: {
          id: '18696',
          name: 'Kaizen Ad CS',
          profileImageUrl: '',
        },
        deliverables: [
          {
            id: 'DE01FKQWW75GCF',
            creative: {
              id: 'CV01FKQWW75BK6',
              file: {
                id:
                  '4a827315f3c741e9bca987ebecb92f8da8863675382944b6b3fff57b0d6e763d6b4ae3f07e424e7eab4212971909a85e/01DD54WF0V9P_Facebook_Feeds_01DD59N28DYD_kza.mp4',
                originalFileName: 'デモプロジェクト1.mp4',
                url:
                  'https://files.kaizenplatform.net/encoded/0/0/fa6c641edfc5e3257c06403462e3a131112836c13d1496277f9d5b01477eb894/f686dfce-149b-4a81-85ce-d064a505385b_prev_480p.mp4',
                mimeType: 'video/mp4',
                size: 9964756,
              },
            },
            attachedThumbnail: {
              id: 'CV01FKQWW767AM',
              file: {
                id:
                  '1652200279af43cda53df63761ebe5ad3fdd31264d4b4730b7a69d1f0550fc86af8dd02979fa4752a2edee997fc93a68/01DD54WF0V9P_Facebook_Feeds_01DD59N2BED9_kza.jpg',
                originalFileName: 'デモプロジェクト1_サムネイル.jpg',
                url: 'https://files.kaizenplatform.net/instance/0/0/d4b8f97c-3114-4313-8a4b-220250b10df1',
                mimeType: 'image/jpeg',
                size: 541788,
              },
            },
            intent:
              '1.動きに緩急を付け、最後まで飽きさせないように工夫しました。2.できる限りテキストを大きく使い、可読性を高くしました。',
            state: 'submitted',
            uploadedAdPlatformKeys: [],
            createdAt: '2021-11-05T11:13:54Z',
            stateUpdatedAt: '2021-11-05T11:13:54Z',
          },
        ],
        modificationRequests: [],
        modificationRequestExpired: true,
        modificationRequestFreeExpiredAt: '2019-07-03T08:00:00Z',
        modificationRequestPoint: 40,
        modificationRequestFreeLimit: 0,
        isNextModificationRequestForAFee: true,
        state: 'submitted',
        proposed: false,
        submittedAt: '2019-06-12T07:55:33Z',
        createdAt: '2021-11-05T11:13:54Z',
        stateUpdatedAt: '2021-11-05T11:13:54Z',
        creativeFormat: {
          id: '190523',
          network: { id: '2', key: 'facebook', name: 'Facebook' },
          placement: {
            id: '2',
            key: 'facebook_feeds',
            name: 'Feeds',
            basicMerchandises: [
              {
                isModificationRequestable: true,
                creativeType: { id: '1', key: 'video', name: 'Video' },
              },
              {
                isModificationRequestable: true,
                creativeType: {
                  id: '2',
                  key: 'static_image',
                  name: 'Static Image',
                },
              },
            ],
          },
          attribute: {
            aspectRatio: {
              supportingAspectRatioId: '1',
              size: { height: 1080.0, width: 1920.0 },
              aspectRatio: { height: 9, width: 16 },
            },
            playbackTime: { supportingPlaybackTimeId: '2', seconds: 15 },
          },
          creativeType: { id: '1', key: 'video', name: 'Video' },
        },
        organization: {
          id: '29067',
          name: '牧野フライス製作所（Sales）',
          pointBalance: 0,
          features: { canOpenOfferWhenDisagreed: false },
          businessRegion: {
            key: 'jp',
            idBusinessRegion: 'japan',
            timeZone: 'Asia/Tokyo',
          },
        },
        assignmentId: 'DEMOA1',
        finalized: false,
      },
    },
  },
  {
    data: {
      creation: {
        id: 'CR01FKQWW77KVY',
        projectId: 'PJ01FKQWW7370Q',
        creationSetId: 'CS01FKQWW74B7X',
        latestDeliverableUrl:
          'https://files.kaizenplatform.net/encoded/0/0/1658a99ab3d4a1d3364aebf64a338972b46e369a1c319b7eafda0311a24fc5f7/e1a3693c-92eb-4659-813f-db78cc4031d9_prev_480p.mp4',
        assignee: {
          id: '18696',
          name: 'Kaizen Ad CS',
          profileImageUrl: '',
        },
        deliverables: [
          {
            id: 'DE01FKQWW77Y3N',
            creative: {
              id: 'CV01FKQWW77SKP',
              file: {
                id:
                  '3c53940fb53c497fb3ae0f9a9db1de57ed4218023b8948f7bfd6550565355f98621d3cc3ecd14ebc910bd28aca592b19/01DD54WF0V9P_Facebook_Feeds_01DD59ZT5KD5_kza.mp4',
                originalFileName: 'デモプロジェクト2.mp4',
                url:
                  'https://files.kaizenplatform.net/encoded/0/0/1658a99ab3d4a1d3364aebf64a338972b46e369a1c319b7eafda0311a24fc5f7/e1a3693c-92eb-4659-813f-db78cc4031d9_prev_480p.mp4',
                mimeType: 'video/mp4',
                size: 11633782,
              },
            },
            attachedThumbnail: {
              id: 'CV01FKQWW78K2K',
              file: {
                id:
                  'c92dcd6c9f7a4f49aaeeac68c13242e28a6abe8e56ae4fd58b07cb1fede0a022e11cbc4c60174e34afcc1bb9ab0831c1/01DD54WF0V9P_Facebook_Feeds_01DD59ZT95DG_kza.png',
                originalFileName: 'デモプロジェクト2_サムネイル.png',
                url: 'https://files.kaizenplatform.net/instance/0/0/11bff3c3-c433-48ba-91f5-d481d4576a3e',
                mimeType: 'image/png',
                size: 103693,
              },
            },
            intent:
              '1. モバイルでも見やすいよう、文字は大きめにしました。また、途中で飽きられないよう、テンポ感を大切にしました。\r\n2. 要所々々でイラストを使うなどして、単調にならないよう、また、理解の浅いユーザーにもわかりやすいように工夫しました。\r\n3. 「もっと詳しく知りたい」、「資料請求してみたい」と思ってもらえるよう、iDeCoの魅力（手数料0円等）とKAIZEN証券ならではの魅力の両方が伝わる内容にしました。\r\n4. トンマナ以外は参考URLの動画を踏襲しても良いとのことでしたので、節税を豚の貯金箱で表現する部分などについて参考にさせていただきました。',
            state: 'submitted',
            uploadedAdPlatformKeys: [],
            createdAt: '2021-11-05T11:13:54Z',
            stateUpdatedAt: '2021-11-05T11:13:54Z',
          },
        ],
        modificationRequests: [],
        modificationRequestExpired: true,
        modificationRequestFreeExpiredAt: '2019-07-03T08:00:00Z',
        modificationRequestPoint: 40,
        modificationRequestFreeLimit: 0,
        isNextModificationRequestForAFee: true,
        state: 'submitted',
        proposed: false,
        submittedAt: '2019-06-12T07:56:15Z',
        createdAt: '2021-11-05T11:13:54Z',
        stateUpdatedAt: '2021-11-05T11:13:54Z',
        creativeFormat: {
          id: '190523',
          network: { id: '2', key: 'facebook', name: 'Facebook' },
          placement: {
            id: '2',
            key: 'facebook_feeds',
            name: 'Feeds',
            basicMerchandises: [
              {
                isModificationRequestable: true,
                creativeType: { id: '1', key: 'video', name: 'Video' },
              },
              {
                isModificationRequestable: true,
                creativeType: {
                  id: '2',
                  key: 'static_image',
                  name: 'Static Image',
                },
              },
            ],
          },
          attribute: {
            aspectRatio: {
              supportingAspectRatioId: '1',
              size: { height: 1080.0, width: 1920.0 },
              aspectRatio: { height: 9, width: 16 },
            },
            playbackTime: { supportingPlaybackTimeId: '2', seconds: 15 },
          },
          creativeType: { id: '1', key: 'video', name: 'Video' },
        },
        organization: {
          id: '29067',
          name: '牧野フライス製作所（Sales）',
          pointBalance: 0,
          features: { canOpenOfferWhenDisagreed: false },
          businessRegion: {
            key: 'jp',
            idBusinessRegion: 'japan',
            timeZone: 'Asia/Tokyo',
          },
        },
        assignmentId: 'DEMOA2',
        finalized: false,
      },
    },
  },
  {
    data: {
      creation: {
        id: 'CR01FKQWW7A5S0',
        projectId: 'PJ01FKQWW7370Q',
        creationSetId: 'CS01FKQWW74B7X',
        latestDeliverableUrl:
          'https://files.kaizenplatform.net/encoded/0/0/1f2aee45a1948f58340e3eb9381dc2caf7641fc9bde95d00c301b8092d26e169/011bd35e-b447-45e6-a434-ec7b75bb01cc_prev_480p.mp4',
        assignee: {
          id: '18696',
          name: 'Kaizen Ad CS',
          profileImageUrl: '',
        },
        deliverables: [
          {
            id: 'DE01FKQWW7AF8G',
            creative: {
              id: 'CV01FKQWW7AAHG',
              file: {
                id:
                  '1d78643bb62040988f1ce96a43302843949204d90072482e96238a1432165857e8da70df690244f8a84e89b3514e756f/01DD54WF0V9P_Facebook_Feeds_01DD5A2AP3KF_kza.mp4',
                originalFileName: 'デモプロジェクト3.mp4',
                url:
                  'https://files.kaizenplatform.net/encoded/0/0/1f2aee45a1948f58340e3eb9381dc2caf7641fc9bde95d00c301b8092d26e169/011bd35e-b447-45e6-a434-ec7b75bb01cc_prev_480p.mp4',
                mimeType: 'video/mp4',
                size: 4198120,
              },
            },
            attachedThumbnail: {
              id: 'CV01FKQWW7B6H9',
              file: {
                id:
                  'd0a6219c7bb0487d983a7a64f0af18a058e878d1205c4cc68dd998baee79a7bef01fa788ebe14532a174b763198c3a6a/01DD54WF0V9P_Facebook_Feeds_01DD5A2AVNWY_kza.mp4',
                originalFileName: 'デモプロジェクト3_サムネイル.mp4',
                url: 'https://files.kaizenplatform.net/instance/0/0/ee2e7f7e-caa5-4681-9bc1-2ca2a7bb53d0',
                mimeType: 'video/mp4',
                size: 4198120,
              },
            },
            intent:
              '1.全体的に文字を大きくして、印象に残るようにしました。2.バナーに合わせたトンマナにし、動画全体に統一感を持たせました。3.テンポよく見せることで最後まで見てもらい、資料請求につながるようにしました。4.文字の大きさにメリハリをつけることで、大事な部分がどこになるのかわかりやすいようにしました',
            state: 'submitted',
            uploadedAdPlatformKeys: [],
            createdAt: '2021-11-05T11:13:55Z',
            stateUpdatedAt: '2021-11-05T11:13:55Z',
          },
          {
            id: 'DE01FKQWW7CAS7',
            creative: {
              id: 'CV01FKQWW7C6N1',
              file: {
                id:
                  '28811eb8a77c48d8a15a98bd6bb0716f457f54040bfe4bb1afd41ffd40dfd9ff2a4ddee74f114807b640cd248984ad6e/01DD54WF0V9P_Facebook_Feeds_01DD5B7K1ADZ_kza.mp4',
                originalFileName: 'デモプロジェクト3.mp4',
                url:
                  'https://files.kaizenplatform.net/encoded/0/0/88fecdb4a504c3a150d6e113452866f72c36848ae9643c1c6bd61edeeb7bfc9e/c2b4c99b-f9c1-431c-869e-b6a3db8115ff_prev_480p.mp4',
                mimeType: 'video/mp4',
                size: 4198120,
              },
            },
            attachedThumbnail: {
              id: 'CV01FKQWW7D0GK',
              file: {
                id:
                  'eeffe1aa3768405f89ee2f5da076403ea219eb5734364381b58d7c76083bd73b974d51842b6345da9d26a1ab42ed57e5/01DD54WF0V9P_Facebook_Feeds_01DD5B7K44DS_kza.jpg',
                originalFileName: 'デモプロジェクト3_サムネイル.jpg',
                url: 'https://files.kaizenplatform.net/instance/0/0/f7ec8c40-05f7-4a73-a6b2-3cbc48360e17',
                mimeType: 'image/jpeg',
                size: 158460,
              },
            },
            intent:
              '1.全体的に文字を大きくして、印象に残るようにしました。2.バナーに合わせたトンマナにし、動画全体に統一感を持たせました。3.テンポよく見せることで最後まで見てもらい、資料請求につながるようにしました。4.文字の大きさにメリハリをつけることで、大事な部分がどこになるのかわかりやすいようにしました',
            state: 'submitted',
            uploadedAdPlatformKeys: [],
            createdAt: '2021-11-05T11:13:55Z',
            stateUpdatedAt: '2021-11-05T11:13:55Z',
          },
        ],
        modificationRequests: [],
        modificationRequestExpired: true,
        modificationRequestFreeExpiredAt: '2019-07-03T08:00:00Z',
        modificationRequestPoint: 40,
        modificationRequestFreeLimit: 0,
        isNextModificationRequestForAFee: true,
        state: 'submitted',
        proposed: false,
        submittedAt: '2019-06-12T08:00:52Z',
        createdAt: '2021-11-05T11:13:55Z',
        stateUpdatedAt: '2021-11-05T11:13:55Z',
        creativeFormat: {
          id: '190523',
          network: { id: '2', key: 'facebook', name: 'Facebook' },
          placement: {
            id: '2',
            key: 'facebook_feeds',
            name: 'Feeds',
            basicMerchandises: [
              {
                isModificationRequestable: true,
                creativeType: { id: '1', key: 'video', name: 'Video' },
              },
              {
                isModificationRequestable: true,
                creativeType: {
                  id: '2',
                  key: 'static_image',
                  name: 'Static Image',
                },
              },
            ],
          },
          attribute: {
            aspectRatio: {
              supportingAspectRatioId: '1',
              size: { height: 1080.0, width: 1920.0 },
              aspectRatio: { height: 9, width: 16 },
            },
            playbackTime: { supportingPlaybackTimeId: '2', seconds: 15 },
          },
          creativeType: { id: '1', key: 'video', name: 'Video' },
        },
        organization: {
          id: '29067',
          name: '牧野フライス製作所（Sales）',
          pointBalance: 0,
          features: { canOpenOfferWhenDisagreed: false },
          businessRegion: {
            key: 'jp',
            idBusinessRegion: 'japan',
            timeZone: 'Asia/Tokyo',
          },
        },
        assignmentId: 'DEMOA3',
        finalized: false,
      },
    },
  },
];

export const getDemoCreation = (id: string) => demoCreationData.map((d) => d.data.creation).find((cs) => cs.id === id);
